var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":_vm.handleRouterTo()}},[_vm._v(" 单双大小历史 ")])}
var staticRenderFns = []

export { render, staticRenderFns }